import { forwardRef, Heading, HeadingProps } from '@chakra-ui/react';

export const H4 = forwardRef<HeadingProps, 'h4'>((props, ref) => {
    return <Heading as="h4" size="h4" ref={ref} {...props} />;
});
